<template>
  <v-navigation-drawer
    v-model="menu_lateral.abierto"
    temporary
    app
    style="z-index: 20"
  >
    <v-list nav dense>
      <v-list-item style="background-color: #5ca7dc" color="mx-0">
        <v-list-item-content>
          <v-list-item-title class="white--text" style="letter-spacing: 1px">
            {{ usuario.nombre_vista }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>

      <v-list dense nav>
        <v-list-item
          v-for="item in items"
          :key="item.title"
          link
          v-show="!item.ocultar"
          @click.stop="action_click(item.title)"
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import Menu_lateral from "@/objetos/menu_lateral.js";
import host from "@/objetos/host.js";
const { PROTOCOLO, HOST, PORT } = host;
const modulo = "login";
import Usuario from "@/objetos/usuario";

export default {
  name: "MenuLateral",
  data: () => ({
    items: [
      { title: "Modificar Datos", icon: "mdi-account",},
      { title: "¿Necesitas Ayuda?", icon: "mdi-whatsapp", ocultar: false},
      { title: "Cerrar sesión", icon: "mdi-exit-to-app",},
    ],
    usuario: Usuario,
    menu_lateral: Menu_lateral,
  }),  
  created() {    
    this.items.forEach(element => {            
      if(!this.usuario.direccion_soporte && element.title == "¿Necesitas Ayuda?") element.ocultar = true
    });
	},
  methods: {
    action_click(titulo) {
      switch (titulo) {
        case "Modificar Datos":
          this.menu_lateral.abierto = !this.menu_lateral.abierto;
          this.$router.push("/modificar_datos");
          break;  
        case "¿Necesitas Ayuda?":
          this.telefono_soporte();
          break;    
        case "Cerrar sesión":
          this.$cookie.delete("pwst");
          window.location = `${PROTOCOLO}//${HOST}:${PORT}/${modulo}`;
          break;
      }
    },
    telefono_soporte(){
      window.open(this.usuario.direccion_soporte,'_blank');
    }
  },
};
</script>